import App2 from "./App.js";
import * as mod from "/web_modules/mime-to-jmap.js";
(async () => {
  console.log(mod);
  await mod.ready;
  console.log("wasm loaded");
})();
console.log("document body is", document.body);
var app = new App2({
  target: document.body
});
export default app;
